var UtmParamEnum;
(function (UtmParamEnum) {
    UtmParamEnum["Source"] = "utm_source";
    UtmParamEnum["Medium"] = "utm_medium";
    UtmParamEnum["Campaign"] = "utm_campaign";
    UtmParamEnum["Content"] = "utm_content";
    UtmParamEnum["Name"] = "utm_name";
    UtmParamEnum["Term"] = "utm_term";
    UtmParamEnum["InitialSource"] = "initial_utm_source";
    UtmParamEnum["InitialMedium"] = "initial_utm_medium";
    UtmParamEnum["InitialCampaign"] = "initial_utm_campaign";
    UtmParamEnum["InitialContent"] = "initial_utm_content";
    UtmParamEnum["InitialName"] = "initial_utm_name";
    UtmParamEnum["InitialTerm"] = "initial_utm_term";
})(UtmParamEnum || (UtmParamEnum = {}));
/** UTM middleware to inject predefined parameters into links depending on options */
export function SetUtmParametersMiddleware(options) {
    return (properties, element, next) => {
        let url;
        try {
            url = new URL(properties.href);
        }
        catch (err) {
            // In case it's not a valid format the middleware is skipped without affecting next ones
            return next();
        }
        const urlParams = url.searchParams;
        let existingUtmParams = false;
        Object.values(UtmParamEnum).forEach(utmKey => {
            if (urlParams.has(utmKey)) {
                if (options.forceIfPresent !== undefined &&
                    options.forceIfPresent === true) {
                    urlParams.delete(utmKey);
                }
                else {
                    existingUtmParams = true;
                }
            }
        });
        if (!existingUtmParams) {
            for (const [utmKey, utmValue] of Object.entries(options.params)) {
                urlParams.set(utmKey, utmValue);
            }
        }
        properties.href = url.toString();
        next();
    };
}
//# sourceMappingURL=set-utm-parameters.js.map